export default __webpack_public_path__ + "static/media/Damaso_No15Open_1.328d1ea8.jpg";